// extracted by mini-css-extract-plugin
module.exports = {"image-container":"imageResponsive_image-container__Ly51u","image":"imageResponsive_image__d7afl"};